import styled from "styled-components";
import {Checkbox, Radio} from "antd";

export const RadioContainer = styled.div`
    margin: auto;
`;

export const RadioList = styled(Radio)`
    display: block;
    height: 30px;
    line-height: 30px;
`;
export const BottomCheckbox = styled(Checkbox)`
    margin-top: 20px;
    margin-left: 15px;
    margin-right: 10px;
`;
